import L from 'leaflet';
export class DataMarker extends L.Marker {
    data = {};
    constructor(latLng, data, options) {
        super(latLng, options);
        this.setData(data);
    }
    getData() { return this.data; }
    setData(data) { this.data = data; }
}
